module.exports = __webpack_public_path__ + "img/login-logo.7577f131.png";